import {
    doc,
    setDoc,
    updateDoc,
    arrayUnion,
    arrayRemove,
    deleteDoc,
    collection,
    query,
    where,
    getDocs,
    getDoc, // أضف هذا السطر
  } from "firebase/firestore";
  import { db } from "../firebaseConfig";
  import toast, { Toaster } from 'react-hot-toast';
  
  // إنشاء كورس جديد
  export const createCourse = async (courseData, teacherId) => {
    try {
      const courseRef = doc(collection(db, "courses"));
      await setDoc(courseRef, {
        ...courseData,
        teacherId,
        subscribedStudents: [],
      });
      toast.success("تم إنشاء الكورس بنجاح! 🎉");
    } catch (error) {
      toast.error("حدث خطأ أثناء إنشاء الكورس: " + error.message);
    }
  };
  
  // إضافة طالب مشترك
  export const subscribeToCourse = async (courseId, studentId) => {
    try {
      const courseRef = doc(db, "courses", courseId);
      await updateDoc(courseRef, {
        subscribedStudents: arrayUnion(studentId),
      });
      toast.success("تم الاشتراك في الكورس بنجاح! 🎉");
    } catch (error) {
      toast.error("حدث خطأ أثناء الاشتراك: " + error.message);
    }
  };
  
  // إزالة طالب مشترك
  export const unsubscribeFromCourse = async (courseId, studentId) => {
    try {
      const courseRef = doc(db, "courses", courseId);
      await updateDoc(courseRef, {
        subscribedStudents: arrayRemove(studentId),
      });
      toast.success("تم إلغاء الاشتراك من الكورس بنجاح! 🎉");
    } catch (error) {
      toast.error("حدث خطأ أثناء إلغاء الاشتراك: " + error.message);
    }
  };
  
  // جلب الكورسات الخاصة بمعلم
  export const fetchTeacherCourses = async (teacherId) => {
    try {
      const coursesRef = collection(db, "courses");
      const q = query(coursesRef, where("teacherId", "==", teacherId));
      const querySnapshot = await getDocs(q);
      const courses = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      return courses;
    } catch (error) {
      console.error("حدث خطأ أثناء جلب الكورسات: ", error);
      return [];
    }
  };
  
  // جلب الكورسات المشترك بها طالب
  export const fetchStudentCourses = async (studentId) => {
    try {
      const coursesRef = collection(db, "courses");
      const q = query(coursesRef, where("subscribedStudents", "array-contains", studentId));
      const querySnapshot = await getDocs(q);
      const courses = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      return courses;
    } catch (error) {
      console.error("حدث خطأ أثناء جلب الكورسات: ", error);
      return [];
    }
  };
  
  // جلب الدرس الأول من كورس
  export const fetchFirstLesson = async (courseId) => {
    try {
      const courseRef = doc(db, "courses", courseId);
      const courseSnap = await getDoc(courseRef); // تم استيراد getDoc الآن
      if (courseSnap.exists()) {
        const courseData = courseSnap.data();
        return courseData.lessons[0];
      } else {
        throw new Error("الكورس غير موجود!");
      }
    } catch (error) {
      console.error("حدث خطأ أثناء جلب الدرس الأول: ", error);
      return null;
    }
  };
  
  // تحديث معلومات الكورس
  export const updateCourse = async (courseId, updatedData) => {
    try {
      const courseRef = doc(db, "courses", courseId);
      await updateDoc(courseRef, updatedData);
      toast.success("تم تحديث الكورس بنجاح! 🎉");
    } catch (error) {
      toast.error("حدث خطأ أثناء تحديث الكورس: " + error.message);
    }
  };
  
  // حذف كورس
  export const deleteCourse = async (courseId) => {
    try {
      const courseRef = doc(db, "courses", courseId);
      await deleteDoc(courseRef);
      toast.success("تم حذف الكورس بنجاح! 🎉");
    } catch (error) {
      toast.error("حدث خطأ أثناء حذف الكورس: " + error.message);
    }
  };
  
  // جلب جميع الكورسات
  export const fetchAllCourses = async () => {
    try {
      const coursesRef = collection(db, "courses");
      const querySnapshot = await getDocs(coursesRef);
      const courses = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      return courses;
    } catch (error) {
      console.error("حدث خطأ أثناء جلب الكورسات: ", error);
      return [];
    }
  };
  
  // جلب دروس كورس معين
  export const fetchCourseLessons = async (courseId) => {
    try {
      const courseRef = doc(db, "courses", courseId);
      const courseSnap = await getDoc(courseRef); // تم استيراد getDoc الآن
      if (courseSnap.exists()) {
        const courseData = courseSnap.data();
        return courseData.lessons;
      } else {
        throw new Error("الكورس غير موجود!");
      }
    } catch (error) {
      console.error("حدث خطأ أثناء جلب الدروس: ", error);
      return [];
    }
  };